import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, FormControl, Typography, useTheme, FormHelperText, Button, } from "@mui/material";
import { useEffect, useRef } from "react";
import { Controller, useForm } from "react-hook-form";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Calendar } from "@phosphor-icons/react";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";
const DashboardTopHeader = ({ filters, setFilters, }) => {
    const theme = useTheme();
    const hiddenButtonRef = useRef(null);
    const { t: translate } = useTranslation();
    const { reset, control, handleSubmit, setError, clearErrors, formState: { errors }, } = useForm({
        defaultValues: filters,
    });
    const onSubmit = (data) => {
        if (!data.startDate) {
            setError("startDate", {
                type: "manual",
                message: translate("Start Date is required"),
            });
            return;
        }
        if (!data.endDate) {
            setError("endDate", {
                type: "manual",
                message: translate("End Date is required"),
            });
            return;
        }
        if (data.startDate >= data.endDate) {
            setError("startDate", {
                type: "manual",
                message: translate("Start date must be Lesser than end date"),
            });
            setError("endDate", {
                type: "manual",
                message: translate("End date must be greater than start date"),
            });
            return;
        }
        clearErrors("startDate");
        setFilters(data);
    };
    const buttonClicked = () => {
        // Trigger click event on the hidden button
        if (hiddenButtonRef.current) {
            hiddenButtonRef.current.click();
        }
    };
    // Follow the committed filters — this is what makes a session-restored range
    // (item #2) land in the form on mount and after every Toepassen. The old
    // version reset to a one-off snapshot taken at first render, so a range
    // restored from filter memory never reached the form.
    useEffect(() => {
        reset(filters);
    }, [filters, reset]);
    return (_jsxs(Box, { sx: {
            display: "flex",
            justifyContent: "space-between",
            flexDirection: { xs: "column", md: "row" },
        }, children: [_jsx(Box, { sx: { padding: { xs: "12px 0px", md: "24px 0px" } }, children: _jsx(Typography, { variant: "h1", sx: { color: theme.palette.text.primary }, children: "Dashboard" }) }), _jsxs(Box, { sx: {
                    display: "flex",
                    padding: { xs: "8px 0px", md: "24px 0px" },
                    gap: { xs: 1, md: 2 },
                    flexDirection: { sm: "row", xs: "column", md: "row" },
                }, children: [_jsx(Box, { sx: { display: "flex", alignItems: "center" }, children: _jsxs(Typography, { children: [translate("selectRange"), ":"] }) }), _jsxs("form", { onSubmit: handleSubmit(onSubmit), children: [_jsxs(Box, { sx: {
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    alignItems: "center",
                                    gap: { xs: 1, md: 2 },
                                }, children: [_jsx(Controller, { name: "startDate", control: control, render: ({ field }) => (_jsxs(FormControl, { variant: "outlined", sx: {
                                                padding: "2px",
                                            }, children: [_jsx(LocalizationProvider, { dateAdapter: AdapterDayjs, children: _jsx(DatePicker, { value: field.value ? dayjs(field.value) : null, views: ["day", "month", "year"], label: "Startdatum", slots: { openPickerIcon: Calendar }, onChange: (date) => {
                                                            const formattedDate = date && dayjs(date).format("YYYY-MM-DD");
                                                            field.onChange(formattedDate);
                                                        }, sx: { width: "100%" }, format: "DD-MM-YYYY" }) }), _jsx(FormHelperText, { error: true, children: errors.startDate && errors.startDate.message })] })) }), _jsx(Controller, { name: "endDate", control: control, rules: {
                                            required: translate("End date is required"),
                                            // validate: (value) => {
                                            //   if (!value) {
                                            //     return true; // Skip validation if start date is not set
                                            //   }
                                            //   return (
                                            //     value >= filters.startDate ||
                                            //     translate("End date must be greater than start date")
                                            //   );
                                            // },
                                        }, render: ({ field }) => (_jsxs(FormControl, { variant: "outlined", sx: {
                                                padding: "2px",
                                            }, children: [_jsx(LocalizationProvider, { dateAdapter: AdapterDayjs, children: _jsx(DatePicker, { value: field.value ? dayjs(field.value) : null, views: ["day", "month", "year"], label: "Einddatum", slots: { openPickerIcon: Calendar }, onChange: (date) => {
                                                            const formattedDate = date && dayjs(date).format("YYYY-MM-DD");
                                                            field.onChange(formattedDate);
                                                        }, 
                                                        // onBlur={field.onBlur} // Ensure that onBlur event is propagated to trigger validation
                                                        sx: { width: "100%" }, format: "DD-MM-YYYY" }) }), _jsx(FormHelperText, { error: true, children: errors.endDate && errors.endDate.message })] })) }), _jsx(Button, { type: "submit", variant: "contained", size: "medium", 
                                        // endIcon={<MagnifyingGlass size={20} />}
                                        //disabled={saving}
                                        sx: { fontSize: { xs: "12px", sm: "12px", md: "14px" } }, onClick: buttonClicked, children: "Toepassen" })] }), _jsx("button", { ref: hiddenButtonRef, type: "submit", hidden: true, children: "Submit" })] })] })] }));
};
export default DashboardTopHeader;
